import React, { useState, useEffect, useContext } from 'react';
import AuthenticationService from '../../services/authentication-service/authentication-service';
import {
    MaintenanceScheduleLanding,
    MaintenanceScheduleDetails,
} from '../../components/sections';
import useSeoConfig from '../../hooks/use-seo-config';
import ServerContext from '../../contexts/serverContext';
import useUserProfile from '../../hooks/use-user-profile';
import serverSideService from '../../services/server-side-service/server-side-service';
import isWebviewCheck from '../../components/utils/webviewCheck/webviewCheck';
import { VehicleAttributes } from '../../models/vehicle-attributes';
import { useAnalytics } from '../../hooks/use-analytics';

export const MaintenanceScheduleLandingView = () => {
    const isWebview = isWebviewCheck();
    const [authenticatedState, setAuthenticatedUser] = useState('');
    const authenticationService = new AuthenticationService();
    const serverContext = useContext(ServerContext);
    const userSelectedVin =
        typeof window === 'undefined'
            ? serverContext.profile?.vin
            : window.sessionStorage.getItem('selectedVin');
    const currentVin = serverContext.webviewData?.vin
        ? serverContext.webviewData?.vin
        : userSelectedVin;
    const [fireEvents] = useAnalytics();
    const [selectedVin, setSelectedVin] = useState<string>(currentVin);
    const scrollPageToTop = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };
    const profile = useUserProfile();
    const [vehiclesData, setVehiclesData] = useState<VehicleAttributes[]>([]);
    const [uomDistance, setUomDistance] = useState<number>(0);
    const [isAuthenticationCompleted, setIsAuthenticationCompleted] = useState<
        boolean
    >(false);
    const pageName = currentVin
        ? 'maintenance-schedule-details'
        : 'maintenance-schedule-landing';
    useSeoConfig(pageName, 'maintenance-schedule');
    const triggerLoadAnalytics = () => {
        fireEvents(
            ['maintenance-schedule-landing'],
            undefined,
            {
                fieldName: 'your vehicle',
            },
            false
        );
    };
    useEffect(() => {
        scrollPageToTop();
        authenticationService
            .onIsAuthenticated()
            .then((isAuthenticated: boolean) => {
                setIsAuthenticationCompleted(true);
                if (isAuthenticated) {
                    setAuthenticatedUser('loggedIn');
                } else {
                    setAuthenticatedUser('notLoggedIn');
                }
            });
    }, []);
    useEffect(() => {
        if (profile) {
            setVehiclesData(
                profile.vehicles.map(vehicle => {
                    return {
                        year: parseInt(vehicle.modelYear, 10),
                        make: vehicle.make,
                        model: vehicle.modelName,
                        vin: vehicle.vin,
                        uomSpeed: profile.profile.uomSpeed,
                        nickName: vehicle.nickName,
                        modelYear: vehicle.modelYear,
                        vehicleMake: vehicle.make,
                        modelName: vehicle.modelName,
                    };
                })
            );
            setUomDistance(profile.profile?.uomDistance);
        }
        triggerLoadAnalytics();
    }, [profile]);
    const loginHandler = (action: string) => {
        if (action === 'signin') {
            authenticationService.login();
        } else if (action === 'register') {
            authenticationService.register();
        }
    };

    const goToMaintenanceScheduleViewDetails = (vin: string) => {
        if (serverSideService.isClientSide()) {
            sessionStorage.setItem('selectedVin', vin);
            sessionStorage.setItem('retainedVIN', vin);
        }
        setSelectedVin(vin);
    };
    const isUserWithCars =
        authenticatedState === 'loggedIn' && vehiclesData.length > 0;

    return (
        <>
            {selectedVin && (
                <MaintenanceScheduleDetails
                    vin={selectedVin}
                    uomDistance={uomDistance}
                    page={'Maintenance Schedule Details'}
                    isAuthenticated={authenticatedState}
                />
            )}
            {!selectedVin && (
                <MaintenanceScheduleLanding
                    isAuthenticated={authenticatedState}
                    loginClick={loginHandler}
                    goToMaintenanceScheduleViewDetails={
                        goToMaintenanceScheduleViewDetails
                    }
                    page={'Maintenance Schedule'}
                    isWebview={isWebview}
                    isAuthenticationCompleted={isAuthenticationCompleted}
                    vehiclesData={vehiclesData}
                    isUserWithCars={isUserWithCars}
                />
            )}
        </>
    );
};
export default MaintenanceScheduleLandingView;
